import { render, staticRenderFns } from "./DownloadDrinkCoachApp.vue?vue&type=template&id=745665ec&scoped=true&"
import script from "./DownloadDrinkCoachApp.vue?vue&type=script&lang=ts&"
export * from "./DownloadDrinkCoachApp.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadDrinkCoachApp.vue?vue&type=style&index=0&id=745665ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745665ec",
  null
  
)

export default component.exports